
<ValidationObserver ref="observer" v-slot="{ invalid, validate }" tag="div">
  <b-form
    :id="'form-' + uid"
    :action="formAction"
    :method="content.typeRequete"
    @input="validate({ silent: true })"
  >
    <!-- Le b-link est nécessaire pour récupérer l'url pout l'input retURL. jel_getLienBinding est
      monté pour gérer la création de l'url par v-bind et est non compatible pour utilisation simple
      directement dans l'input retURL -->
    <b-link id="urlRetour" v-bind="jel_getLienBinding(content.lien)" class="d-none" />
    <input type="hidden" name="orgid" :value="inputValueOrgId" />
    <input type="hidden" name="retURL" :value="urlRetour()" />
    <input type="hidden" :name="inputValueLangueContact" :value="$i18n.locale === 'en' ? 0 : 1" />

    <RadioComboFiltre :content="contentRadioComboFiltre" class="mb-2" />
    <AireTexte :content="contentAireTexte" />

    <Titre
      :content="{
        titre: content.libTitreBlocInfo,
        type: 'titre',
        classeCSS: 'pt-1 mb-2',
      }"
    />

    <PrenomNom :content="contentPrenomNom" />
    <Courriel :content="contentCourriel" />
    <input
      :id="'sumbit-' + uid"
      type="submit"
      name="submit"
      :value="content.libBoutonEnvoyer"
      class="btn btn-primaire hauteur d-flex px-4 mx-auto mx-md-0"
      :disabled="invalid"
    />
  </b-form>
</ValidationObserver>
